import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({ spacing, palette }) => ({
  tab: {
    minWidth: "50%",
  },
  tabRoot: {
    color: palette.tableRowTitle.main,
    textTransform: "capitalize",
    fontSize: "16px",
    fontWeight: 500,
  },
  selectedTab: {
    color: palette.primary.main,
  },
  tabsFlexContainer: {
    width: "100%",
  },
  cardIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    marginTop: spacing(1),
    color: palette.primary.main,
  },
}));
